import CloseIcon from "@styles/all-images/icons/closeblack.svg";

interface TierRejectionReasonProps {
  onClose: () => void;
  onSubmit: () => void;
}

const TierRejectionReason: React.FC<TierRejectionReasonProps> = ({
  onClose,
  onSubmit,
}: TierRejectionReasonProps) => {
  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
      <div className="tw-bg-white tw-rounded-lg tw-w-[400px]">
        <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-4 tw-border-b">
          <div></div>
          <h2 className="tw-text-base tw-font-semibold">Rejection Reason</h2>
          <button onClick={onClose}>
            <img src={CloseIcon} alt="Close" className="tw-w-auto tw-h-auto" />
          </button>
        </div>
        <div className="tw-p-4">
          <p>
            The document has been rejected because the directors' details have
            not been verified against the CIPC records, and the financial
            year-end has either been incorrectly entered or does not align with
            the registered details.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TierRejectionReason;
